import moment from "moment/moment";

export const currentYear = new Date().getFullYear();
export const currentDate = new Date();

export const getDaysInMonth = (date) => {
  const month = date.getMonth();
  const year = date.getFullYear();
  return new Date(year, month + 1, 0).getDate();
};

export const getDaysInYear = (year) => {
  const start = new Date(year, 0, 1);
  const end = new Date(year, 11, 31);
  return (end - start) / (1000 * 60 * 60 * 24) + 1;
};

export function getDaysListInYear(year) {
  const days = [];
  const startDate = new Date(year, 0, 1);
  const endDate = new Date(year, 11, 31);

  while (startDate <= endDate) {
    days.push(new Date(startDate));
    startDate.setDate(startDate.getDate() + 1);
  }

  return days;
}

export const getNumberOfWeeksInYear = (year) => {
  const firstDay = new Date(year, 0, 1);
  const lastDay = new Date(year, 11, 31);

  const totalDays =
    Math.floor((lastDay - firstDay) / (1000 * 60 * 60 * 24)) + 1;

  return Math.ceil(totalDays / 7);
};

export const getWeeksInYear = (year) => {
  const firstDayOfYear = new Date(year, 0, 1);
  const lastDayOfYear = new Date(year, 11, 31);

  const weeks = [];
  let currentWeek = [];
  let currentDate = new Date(firstDayOfYear);

  while (currentDate <= lastDayOfYear) {
    currentWeek.push(new Date(currentDate));

    if (
      currentWeek.length === 7 ||
      currentDate.getTime() === lastDayOfYear.getTime()
    ) {
      weeks.push(currentWeek);
      currentWeek = [];
    }

    currentDate.setDate(currentDate.getDate() + 1);
  }

  return weeks;
};

export const getWeeksInYear2 = (year) => {
  const isMonday = (date) => date.getDay() === 1;

  const isSunday = (date) => date.getDay() === 0;

  const firstDayOfYear = new Date(year, 0, 1);
  let startDate = new Date(firstDayOfYear);
  while (!isMonday(startDate)) {
    startDate.setDate(startDate.getDate() - 1);
  }

  const lastDayOfYear = new Date(year, 11, 31);
  let endDate = new Date(lastDayOfYear);
  while (!isSunday(endDate)) {
    endDate.setDate(endDate.getDate() + 1);
  }

  const weeks = [];
  let currentWeek = [];
  let currentDate = new Date(startDate);

  while (currentDate <= endDate) {
    currentWeek.push(new Date(currentDate));

    if (isSunday(currentDate)) {
      weeks.push(currentWeek);
      currentWeek = [];
    }

    currentDate.setDate(currentDate.getDate() + 1);
  }

  return weeks;
};

export const getNumberOfWeeksInMonth = (date) => {
  const totalDays = getDaysInMonth(date);
  return Math.ceil(totalDays / 7);
};

export const months = Array.from({ length: 12 }, (_, i) => {
  const date = new Date(currentYear, i, 1);
  const daysInMonth = new Date(currentYear, i + 1, 0).getDate();

  return {
    name: date.toLocaleString("default", { month: "long" }),
    days: new Date(currentYear, i + 1, 0).getDate(),
    startDate: date,
    daysArray: Array.from(
      { length: daysInMonth },
      (_, dayIndex) => new Date(currentYear, i, dayIndex + 1)
    ),
  };
});

export function getTodayPosition(viewType, currentDate, testDate = null) {
  const today = testDate ? new Date(testDate) : new Date();

  switch (viewType.toLowerCase()) {
    case "monthly": 
    case "month": 
    {
      const monthWidth = 241;
      const monthIndex = today.getMonth();
      const dayOffset = today.getDate() - 1;
      const daysInMonth = new Date(currentYear, monthIndex + 1, 0).getDate();

      const dayWidth = monthWidth / daysInMonth;
      return monthIndex * monthWidth + dayOffset * dayWidth - dayWidth;
    }

    case "weekly": 
    case "week": {
      const weeks = getWeeksInYear2(currentYear);
      const weekWidth = 241;

      let position = 0;

      for (let i = 0; i < weeks.length; i++) {
        const currentWeek = weeks[i];
        const weekStart = currentWeek[0];
        const weekEnd = currentWeek[currentWeek.length - 1];

        const daysInWeek = currentWeek.length;
        const dayWidth = weekWidth / daysInWeek;

        const weekContainsToday = currentWeek.some(
          (date) =>
            date.toLocaleDateString() === currentDate.toLocaleDateString()
        );

        if (weekContainsToday) {
          const dayInWeek = currentWeek.findIndex(
            (date) =>
              date.toLocaleDateString() === currentDate.toLocaleDateString()
          );

          position = i * weekWidth + (dayInWeek+1) * dayWidth;
          break;
        }

        if (weekStart < today && weekEnd > today) {
          position = i * weekWidth;
          break;
        }
      }

      return position;
    }

    default:
      return 0;
  }
}
export const calculateWeekWidths = (year) => {
  const weeks = getWeeksInYear2(year);
  const MONTH_WIDTH = 241.05;
  
  return weeks.map(week => {
    let totalWidth = 0;
    
    
    week.forEach(day => {
      if (day.getFullYear() === year) {
        const month = day.getMonth();
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        const widthPerDay = MONTH_WIDTH / daysInMonth;
        totalWidth += widthPerDay;
      }
    });
    
    return totalWidth;
  });
};



//New Range Logic

export const getDaysBetweenYears = (startYear, endYear) => {
  const start = moment().year(startYear).startOf("year");
  const end = moment().year(endYear).endOf("year");

  return end.diff(start, "days") + 1; 
};

export const getNumberOfWeeksBetweenYears = (startYear, endYear) => {

  const totalDays = getDaysBetweenYears(startYear, endYear);

  return Math.ceil(totalDays / 7);
};

export const getNumberOfQuartersBetweenYears = (startYear, endYear) => {
  return (endYear - startYear + 1) * 4;
}

export const getNumberOfYearsBetweenYears = (startYear, endYear) => {
  return (endYear - startYear + 1);
}

export const getMonthsInRange = (startYear, endYear) => {
  const months = [];

  for (let year = startYear; year <= endYear; year++) {
    for (let month = 0; month < 12; month++) {
      const date = new Date(year, month, 1);
      const daysInMonth = new Date(year, month + 1, 0).getDate();

      months.push({
        year,
        name: date.toLocaleString("default", { month: "long" }),
        days: daysInMonth,
        startDate: date,
        daysArray: Array.from(
          { length: daysInMonth },
          (_, dayIndex) => new Date(year, month, dayIndex + 1)
        ),
      });
    }
  }

  return months;
};


export const getWeeksInYearRange = (startYear, endYear) => {
  const weeks = [];

  // get first Monday before/at start of range
  let startDate = moment().year(startYear).startOf("year").startOf("week").add(1, "day");
  if (startDate.day() !== 1) {
    startDate = startDate.subtract((startDate.day() + 6) % 7, "days");
  }

  // get last Sunday after/at end of range
  let endDate = moment().year(endYear).endOf("year").endOf("week");
  if (endDate.day() !== 0) {
    endDate = endDate.add(7 - endDate.day(), "days");
  }

  let currentDate = moment(startDate);
  let currentWeek = [];

  while (currentDate.isSameOrBefore(endDate)) {
    currentWeek.push(currentDate.clone().toDate());

    if (currentDate.day() === 0) {
      weeks.push(currentWeek);
      currentWeek = [];
    }

    currentDate.add(1, "day");
  }

  return weeks;
};

export const calculateWeekWidthsInRange = (startYear, endYear) => {
  const weeks = getWeeksInYearRange(startYear, endYear);
  const MONTH_WIDTH = 241.05;

  return weeks.map(week => {
    let totalWidth = 0;

    week.forEach(day => {
      const year = day.getFullYear();
      const month = day.getMonth();
      const daysInMonth = new Date(year, month + 1, 0).getDate();
      const widthPerDay = MONTH_WIDTH / daysInMonth;

      // only count if the day is inside the selected range
      if (year >= startYear && year <= endYear) {
        totalWidth += widthPerDay;
      }
    });

    return totalWidth;
  });
};


export function getDaysInYearRange(startYear, endYear) {
  const days = [];
  let current = moment().year(startYear).startOf("year");
  const end = moment().year(endYear).endOf("year");

  while (current.isSameOrBefore(end)) {
    days.push(current.clone().toDate()); // push as native Date (or keep as moment if you prefer)
    current.add(1, "day");
  }

  return days;
}

export const isCurrentYearInRange = (startYear, endYear) => {
  const currentYear = moment().year();
  return currentYear >= startYear && currentYear <= endYear;
};

export function getTodayPositionForYearRange(viewType, startYear, endYear, testDate = null) {
  const today = testDate ? new Date(testDate) : new Date();
  const todayStr = today.toISOString().slice(0, 10); // YYYY-MM-DD

  switch (viewType.toLowerCase()) {
    case "monthly":
    case "month":
       {
      const months = getMonthsInRange(startYear, endYear);
      const MONTH_WIDTH = 241.5;
      let position = 0;

      for (let i = 0; i < months.length; i++) {
        const month = months[i];
        const daysInMonth = month.days;
        const dayWidth = MONTH_WIDTH / daysInMonth;

        // Check if today is in this month
        if (today.getFullYear() === month.year && today.getMonth() === month.startDate.getMonth()) {
          position += (today.getDate()) * dayWidth; // offset inside current month
          break;
        } else {
          // Add width of full month
          position += MONTH_WIDTH;
        }
      }

      return position;
    }

    case "quarter":{
      const QUARTER_WIDTH = 501;
      let today = moment();
      const quarters = [
        { q: 1, startMonth: 0, endMonth: 2 },
        { q: 2, startMonth: 3, endMonth: 5 },
        { q: 3, startMonth: 6, endMonth: 8 },
        { q: 4, startMonth: 9, endMonth: 11 },
      ];
      let position = 0;

      for (let year = startYear; year <= endYear; year++) {
        for (const quarter of quarters) {
          const quarterStart = moment({ year, month: quarter.startMonth, day: 1 }).startOf("day");
          const quarterEnd = moment({ year, month: quarter.endMonth }).endOf("month").startOf("day");

          if (today.isBetween(quarterStart, quarterEnd, undefined, "[]")) {
            const totalDaysInQuarter = quarterEnd.diff(quarterStart, "days") + 1;
            const dayOfQuarter = today.diff(quarterStart, "days") + 1;
            const dayWidth = QUARTER_WIDTH / totalDaysInQuarter;

            position += dayOfQuarter * dayWidth;
            return position;
          } else {
            position += QUARTER_WIDTH;
          }
        }
      }

      return position;
    }

    case "year": {
      const YEAR_WIDTH = 501; // 4 quarters × 125.25px
      const QUARTER_WIDTH = 125.25;
      let todayMoment = moment(today);
      const quarters = [
        { q: 1, startMonth: 0, endMonth: 2 },
        { q: 2, startMonth: 3, endMonth: 5 },
        { q: 3, startMonth: 6, endMonth: 8 },
        { q: 4, startMonth: 9, endMonth: 11 },
      ];
      let position = 0;

      for (let year = startYear; year <= endYear; year++) {
        for (const quarter of quarters) {
          const quarterStart = moment({ year, month: quarter.startMonth, day: 1 }).startOf("day");
          const quarterEnd = moment({ year, month: quarter.endMonth }).endOf("month").startOf("day");

          if (todayMoment.isBetween(quarterStart, quarterEnd, undefined, "[]")) {
            const totalDaysInQuarter = quarterEnd.diff(quarterStart, "days") + 1;
            const dayOfQuarter = todayMoment.diff(quarterStart, "days") + 1;
            const dayWidth = QUARTER_WIDTH / totalDaysInQuarter;

            position += dayOfQuarter * dayWidth;
            return position;
          } else {
            position += QUARTER_WIDTH;
          }
        }
      }

      return position;
    }

    case "weekly": 
    case "week": 
    {
      const weeks = getWeeksInYearRange(startYear, endYear);
      const WEEK_WIDTH = 241;
      let position = 0;

      for (const week of weeks) {
        const dayIndex = week.findIndex(
          (d) => d.toISOString().slice(0, 10) === todayStr
        );

        const dayWidth = WEEK_WIDTH / week.length;

        if (dayIndex !== -1) {
          position += dayIndex * dayWidth;
          break;
        } else {
          position += WEEK_WIDTH; // full week width
        }
      }

      return position;
    }

    default:
      const DAY_WIDTH = 241;
      const start = moment().year(startYear).startOf("year");

      return (moment().diff(start, "days") + 1) * DAY_WIDTH; 
  }
}

/**
 * Check if a date is a weekend (Saturday or Sunday)
 */
const isWeekend = (date) => {
  const day = moment(date).day();
  return day === 0 || day === 6; // 0 = Sunday, 6 = Saturday
};

/**
 * Calculate the number of weekdays between two dates (excluding weekends)
 */
export const calculateDurationNoWeekends = (startDate, endDate) => {
  if (!startDate || !endDate) return 0;

  const start = moment(startDate);
  const end = moment(endDate);

  if (end.isBefore(start)) return 0;

  let count = 0;
  let current = start.clone();

  while (current.isSameOrBefore(end)) {
    if (!isWeekend(current)) {
      count++;
    }
    current.add(1, 'days');
  }

  return count;
};

/**
 * Calculate end date based on start date and duration (skipping weekends)
 */
export const calculateEndDateNoWeekends = (startDate, duration) => {
  if (!startDate || !duration || duration <= 0) return '';

  let current = moment(startDate);
  let remainingDays = duration;

  // If start date is a weekend, move to next Monday
  while (isWeekend(current)) {
    current.add(1, 'days');
  }

  remainingDays--; // Count the start date as the first day

  while (remainingDays > 0) {
    current.add(1, 'days');
    if (!isWeekend(current)) {
      remainingDays--;
    }
  }

  return current.format('YYYY-MM-DD');
};

/**
 * Calculate start date based on end date and duration (skipping weekends)
 */
export const calculateStartDateNoWeekends = (endDate, duration) => {
  if (!endDate || !duration || duration <= 0) return '';

  let current = moment(endDate);
  let remainingDays = duration;

  // If end date is a weekend, move to previous Friday
  while (isWeekend(current)) {
    current.subtract(1, 'days');
  }

  remainingDays--; // Count the end date as the last day

  while (remainingDays > 0) {
    current.subtract(1, 'days');
    if (!isWeekend(current)) {
      remainingDays--;
    }
  }

  return current.format('YYYY-MM-DD');
};

/**
 * Get today's date in YYYY-MM-DD format
 */
export const getTodayBusinessDateNoWeekends = () => {
  let today = moment();

  // If today is a weekend, move to next Monday
  while (isWeekend(today)) {
    today.add(1, 'days');
  }

  return today.format('YYYY-MM-DD');
};
